// Modern GSAP Marquee Animation
document.addEventListener('DOMContentLoaded', function () {
  // Check if GSAP is loaded and if the marquee element exists
  if (typeof gsap !== 'undefined' && document.querySelector('.gsap-marquee-container')) {
    // Initialize the marquee animation
    const marqueeElements = gsap.utils.toArray('.gsap-marquee-text');

    // Create the infinite scrolling marquee effect
    marqueeElements.forEach((element) => {
      // Clone the text to ensure continuous flow
      const originalText = element.textContent;
      element.innerHTML = originalText + ' ' + originalText + ' ' + originalText;

      // Calculate the width for a complete loop
      const textWidth = element.scrollWidth / 3;

      // Create the horizontal scrolling animation with a modern smooth effect
      gsap.to(element, {
        x: -textWidth,
        ease: 'linear',
        duration: 15, // Slightly faster for a more modern feel
        repeat: -1, // Infinite repeat
        modifiers: {
          x: gsap.utils.unitize((x) => parseFloat(x) % textWidth), // Ensures smooth looping
        },
      });
    });

    // Add hover effect to pause the animation
    const marqueeContainers = document.querySelectorAll('.gsap-marquee-container');

    marqueeContainers.forEach((container) => {
      container.addEventListener('mouseenter', function () {
        // Pause all animations in this container
        gsap.getTweensOf(container.querySelectorAll('.gsap-marquee-text')).forEach((tween) => {
          tween.pause();
        });
      });

      container.addEventListener('mouseleave', function () {
        // Resume all animations in this container
        gsap.getTweensOf(container.querySelectorAll('.gsap-marquee-text')).forEach((tween) => {
          tween.play();
        });
      });
    });
  }
});
